import { render, staticRenderFns } from "./CommentClusters.vue?vue&type=template&id=15199d7c"
import script from "./CommentClusters.vue?vue&type=script&lang=ts"
export * from "./CommentClusters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports